import { useState, useEffect } from "react";
import Table, { Column } from "../../../Components/Tables/Table";
import PageHeader from "../../../Layout/PageHeader";
import historyIcon from "../../../assets/images/history-icon.svg";
import { useParams } from "react-router-dom";
import DynamicDetailGrid from "../../../Components/Grid/DynamicDetailGrid";
import ViewMoreModal from "../../../Components/Modals/ViewMoreModal";
import { HistoryLaoutDataCheckInDetail } from "../../../Data/testData";
import HistoryLayout from "../../../Layout/HistoryLaout";
import { Shipment, ShipmentLine } from "./model/shipment.model";
import { getShipmentDetails } from "./service/shipments.service";
import Loader from "../../../Components/GlobalLoader/Loader";
import { formatDate, formatNumber } from "../../../Utility/Utility";

export default function ShipmentsDetails() {
    const { id } = useParams<{ id: string }>();
    const [isShowCanvas, setShowCanvas] = useState(false);
    const [showViewModal, setViewModal] = useState(false);
    const [shipment, setShipment] = useState<Shipment | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchShipmentDetails();
    }, [id]);

    const fetchShipmentDetails = async () => {
        try {
            setLoading(true);
            const response = await getShipmentDetails(id!);
            setShipment(response.data);
        } catch (error) {
            console.error("Error fetching shipment details:", error);
        } finally {
            setLoading(false);
        }
    };

    const handelViewMoreAction = (data: any) => {
        setViewModal(true);
    };

    const handelCanvas = () => {
        setShowCanvas(!isShowCanvas);
    };

    const handleViewClose = () => setViewModal(false);
    
    const onModalSubmit = () => {
        handleViewClose();
    };

    const historyData = (
            <div
                className="d-flex justify-content-between w-100 align-items-center px-4"
                onClick={handelCanvas}
            >
                <div>
                    <h6 className="cursor-pointer m-0 d-flex align-items-center">
                        <img src={historyIcon} className="me-2" />
                        History
                    </h6>
                </div>
            </div>
    );

    const InboundASNCheckInData = {
        ASNCheckInExpanded: [
            {
                label: 'Client',
                value: shipment?.client?.name ? (<>{shipment?.client?.name}({shipment?.client?.code})</>):'-'
            },
            {
                label: 'Order #',
                value: shipment?.sales_order?.order_number ?? '-'
            },
            {
                label: 'No. of Lines',
                value: shipment?.lines?.length ?? 0
            },
            {
                label: 'Total Quantity',
                value: shipment?.lines?.reduce((acc, line) => acc + Number(line.qty_requested ?? 0), 0) ?? 0
            },
            {
                label: 'Order Date',
                value: formatDate(shipment?.sales_order?.order_date??"") ?? '-'
            },
            {
                label: 'Ship Method',
                value: shipment?.sales_order?.source ?? '-'
            },
            {
                label: 'Ship by Date',
                value: formatDate(shipment?.ship_by_date??"") ?? '-'
            },
            {
                label: 'Shipment Created On',
                value: formatDate(shipment?.create_date??"") ?? '-'
            },
            {
                label: 'Customer Purchase Order',
                value: shipment?.sales_order?.customer_po_number ?? '-'
            },
            {
                label: 'Customer Sales Order',
                value: shipment?.sales_order?.customer_order_number ?? '-'
            },
            {
                label: 'Bill-to Code',
                value: shipment?.customer_bill_to?.name ?? '-'
            },
            {
                label: 'Ship-to Code',
                value: shipment?.customer_ship_to?.name ?? '-'
            },
            {
                label: 'Tracking #',
                value: shipment?.tracking_number ?? '-'
            },
            {
                label: 'Notes',
                value: (
                    <>
                        {shipment?.sales_order?.notes_1 ? (
                            <>
                                {shipment?.sales_order?.notes_1.length > 25 
                                    ? `${shipment?.sales_order?.notes_1.substring(0, 25)}...` 
                                    : shipment?.sales_order?.notes_1}
                                {shipment?.sales_order?.notes_1.length > 25 && (
                                    <div>
                                        {"("}
                                        <span 
                                            className="text-primary cursor-pointer"
                                            onClick={() => handelViewMoreAction(shipment?.sales_order?.notes_1)}
                                        >
                                            View More
                                        </span>
                                        {")"}
                                    </div>
                                )}
                            </>
                        ) : '-'}
                    </>
                )
            },
            {
              label: 'Special Instructions',
              value: (
                  <>
                      {shipment?.sales_order?.special_instructions ? (
                          <>
                              {shipment.sales_order.special_instructions.length > 25 
                                  ? `${shipment.sales_order.special_instructions.substring(0, 25)}...` 
                                  : shipment.sales_order.special_instructions}
                              {shipment.sales_order.special_instructions.length > 25 && (
                                  <div>
                                      {"("}
                                      <span 
                                          className="text-primary cursor-pointer"
                                          onClick={() => handelViewMoreAction(shipment.sales_order.special_instructions)}
                                      >
                                          View More
                                      </span>
                                      {")"}
                                  </div>
                              )}
                          </>
                      ) : '-'}
                  </>
              )
            },
            {
                label: 'Status',
                value: (
                    <>
                     {shipment?.status === "pending" ? (
          <span className="badge asn-overview-status asn-overview-status-border-blue rounded px-4 fs-11 w-auto d-inline-block">
            Pending
          </span>
        ) :shipment?.status === "picking" ? (
          <span className="badge asn-overview-status asn-overview-status-border-blue rounded px-4 fs-11 w-auto d-inline-block">
            Picking
          </span>
        ) :
        shipment?.status === "packing" ? (
          <span className="badge asn-overview-status asn-overview-status-border-blue rounded px-4 fs-11 w-auto d-inline-block">
            Packing
          </span>
        ):shipment?.status === "shipping" ? (
          <span className="badge asn-overview-status asn-overview-status-border-blue rounded px-4 fs-11 w-auto d-inline-block">
            Shipping
          </span>
        ):
        shipment?.status === "shipped" ? (
          <span className="badge asn-overview-status asn-overview-status-border-blue rounded px-4 fs-11 w-auto d-inline-block">
            Shipped
          </span>
        ): (
          <span className="badge asn-overview-status asn-overview-status-border-blue rounded px-4 fs-11 w-auto d-inline-block">
            {shipment?.status ?? '-'}
          </span>
        )
        }
                    </>
            )
            },
        ]
    };

    const columns: Column[] = [
        {
            name: "Line #",
            selector: (row: ShipmentLine) => row.line_number,
        },
        {
            name: "Item Code",
            selector: (row: ShipmentLine) => row.item?.code ?? '-',
        },
        {
            name: "Item Name",
            selector: (row: ShipmentLine) => row.item?.name ?? '-',
        },
        {
            name: "UOM",
            selector: (row: ShipmentLine) => row.uom_code ?? '-',
        },
        {
            name: "Requested Qty",
            selector: (row: ShipmentLine) => formatNumber(row.qty_requested) ?? 0
        },
        {
            name: "Shipped Qty",
            selector: (row: ShipmentLine) => formatNumber(row?.qty_shipped) ?? 0
        },
        {
            name: "Remaining Qty",
            selector: (row: ShipmentLine) => formatNumber(row?.qty_remaining)?? 0
        },
    ];

    if (loading) {
        return <Loader />;
    }

    return (
        <>
            <PageHeader
                listUrl="/outbound/shipments/overview"
                viewType={true}
                isHistoryEnabled={true}
                historyData={[historyData]}
            />
            <h5 className="text-start mt-1 mb-3">{`Shipment (${shipment?.shipment_number})`}</h5>
            <div className="my-2 bg-white rounded py-1 px-2 d-flex flex-column">
                <div className="shipments-details col-12 bg-white col-12 py-1 px-2">
                    <div className="shipments-details flex-column-reverse align-items-center d-flex bg-white">
                        <div className="d-flex col-12 py-4">
                            <div className="d-flex col">
                                <DynamicDetailGrid 
                                    customClassName="mb-2 pt-0 col" 
                                    isExpandable={false} 
                                    columns={3} 
                                    data={InboundASNCheckInData.ASNCheckInExpanded} 
                                />
                            </div>
                            <div className="col d-flex flex-column justify-content-start align-items-end">
                                <div className="supplier position-relative px-4 py-3 mb-5">
                                    <div className="floating-label fs-14 inbound-checkin-supplier position-absolute translate-middle px-2 bg-white">
                                        Ship From
                                    </div>
                                    <div className="name">{shipment?.warehouse?.name ?? '-'}</div>
                                </div>
                                <div className="warehouse position-relative px-4 py-3">
                                    <div className="floating-label fs-14 inbound-checkin-warehouse position-absolute translate-middle px-2 bg-white">
                                        Ship To
                                    </div>
                                    <div className="name">{shipment?.customer_ship_to?.name ?? '-'}</div>
                                    <div className="address mt-2">
                                        {shipment?.customer_ship_to ? (
                                            <>
                                                {shipment.customer_ship_to.address_line_1 && (
                                                    <>
                                                        {shipment.customer_ship_to.address_line_1}
                                                        <br />
                                                    </>
                                                )}
                                                {shipment.customer_ship_to.address_line_2 && (
                                                    <>
                                                        {shipment.customer_ship_to.address_line_2}
                                                        <br />
                                                    </>
                                                )}
                                                {[
                                                    shipment.customer_ship_to.city,
                                                    shipment.customer_ship_to.state_province,
                                                    shipment.customer_ship_to.postal_code,
                                                    shipment.customer_ship_to.country?.name
                                                ]
                                                    .filter(Boolean)
                                                    .join(', ')}
                                            </>
                                        ) : (
                                            '-'
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="my-2 bg-white rounded py-1 px-2">
                <Table
                    columns={columns}
                    data={shipment?.lines ?? []}
                    CheckboxStatus={false}
                    isStripped={true}
                    customClassName="transferDetailsTable"
                />
            </div>

            <ViewMoreModal
                customClassName="header-border"
                show={showViewModal}
                content={shipment?.sales_order?.special_instructions ?? ''}
                onModalSubmit={onModalSubmit}
            />
            <HistoryLayout 
                isShowCanvas={isShowCanvas} 
                showViewScanLogs={true} 
                handelCanvas={handelCanvas} 
                data={HistoryLaoutDataCheckInDetail} 
            />
        </>
    );
}